<template>
  <section class="pt-35 pb-35" :style="{ backgroundColor: `var(--c-${vars.backgroundColor})` }">
    <div class="container">
      <div class="row">
        <div class="col-12 text-center mb-5">
          <h2 v-if="vars.titleText && !vars.titleHtml" class="text-white">{{ vars.titleText }}</h2>
          <div v-if="vars.titleHtml" v-html="vars.titleHtml"></div>
        </div>
      </div>

      <div class="row y-gap-30 md:x-gap-10 md:y-gap-10 justify-content-center tw-w-full">
        <div
          v-for="(item, index) in items"
          :key="index"
          class="d-flex justify-content-center tw-max-w-[200px] md:tw-max-w-[300px]"
        >
          <a :href="item.link" class="n-link">
            <img class="tw-w-full" :src="item.image || item.lightimg" alt="logo" />
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { isThrowStatement } from 'typescript';
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'BrandBanner',

  mixins: [ComponentMixin],

  data() {
    return {};
  },

  computed: {
    descriptions(): Array<{ description: string }> {
      // @ts-ignore - groupedVariables is provided by ComponentMixin
      return this.groupedVariables?.descriptions || [];
    },
    buttons(): Array<{ link: string; type: string; label: string }> {
      // @ts-ignore - groupedVariables is provided by ComponentMixin
      return this.groupedVariables?.buttons || [];
    },
    items() {
      return this.groupedVariables.items;
    },
  },
});
</script>
